import axiosInstance from "./axiosInstance";
import { ApiResponse } from "../types/apiTypes";
import { TeacherJournal, TeacherJournalCreatePayload, TeacherJournalUpdatePayload } from "types/teacherJournalTypes";


// GET /teacher-journals (with pagination + filters)
export const getTeacherJournals = async (
    params: any
): Promise<ApiResponse<TeacherJournal[]>> => {
    const response = await axiosInstance.get<ApiResponse<TeacherJournal[]>>(
        "/teacher-journals",
        { params }
    );
    return response.data;
};

export const getTeacherJournalById = async (
    id: string
): Promise<TeacherJournal> => {
    const response = await axiosInstance.get<ApiResponse<TeacherJournal>>(
        `/teacher-journals/${id}`
    );
    return response.data.data;
};

export const createTeacherJournal = async (
    payload: TeacherJournalCreatePayload
): Promise<TeacherJournal> => {
    const response = await axiosInstance.post<ApiResponse<TeacherJournal>>(
        "/teacher-journals",
        payload
    );
    return response.data.data;
};

export const updateTeacherJournal = async (
    id: string,
    payload: TeacherJournalUpdatePayload
): Promise<TeacherJournal> => {
    const response = await axiosInstance.put<ApiResponse<TeacherJournal>>(
        `/teacher-journals/${id}`,
        payload
    );
    return response.data.data;
};

export const deleteTeacherJournal = async (id: string): Promise<void> => {
    const response = await axiosInstance.delete(`/teacher-journals/${id}`);
    return response.data;
};
